import { Dayjs } from "dayjs";

export class Setting {
    "portMail": number;
    "hostMail": String;
    "userNameMail": String;
    "passwordMail": String;
    "thoiHan": number;
    "sinhNhatQuy": number;
    "noiDungPhan1"?: string;
    "noiDungPhan3"?: string;
    "noiDungPhan4"?: string;
    "duyetNhuCauTaiSan_PhoCVP"?: number;
    "duyetNhuCauTaiSan_CVP"?: number;
    "duyetNhuCauTaiSan_PhoGD"?: number;
    "duyetNhuCauTaiSan_GD"?: number;
    "duyetNhuCauTaiSan_CVVP"?: number;
}

export class NgayNghiInfo{
    "ngayThang": Dayjs;
    "lapHangNam": number;
    "idLoaiNgayNghi": number;
}

export class NgayLamViec {
    "thuHai": number;
    "thuBa": number;
    "thuTu": number;
    "thuNam": number;
    "thuSau": number;
    "thuBay": number;
    "chuNhat": number;
}

export class CauHinhLuong {
    "congDoanMax": number;
    "heSo_LCB_NQL": number;
    "mucLuongDongBH_NQL": number;
    "themGio_NgayThuong": number;
    "themGio_NgayNghi": number;
    "themGio_NgayLe": number;
    "thuLao_CTHDQL": number;
    "thuLao_PCTHDQL": number;
    "thuLao_TVHDQL": number;
}

export class CauHinhThue {
    "soTienToiThieuTinhThueKTX": number;
}

export class CauHinhHanChotKPI {
    "id": number;
    "thangNam"?: Dayjs | null;
    "laMacDinh": boolean;
    "ngayNhanVien": number;
    "ngayLanhDaoPhong": number;
    "ngayBanDieuHanh": number;
    "ghiChu": string;
}

/// Hạn chót trình KPI thực tế của một kỳ, đã lùi qua ngày nghỉ / ngày lễ
export class HanChotKPIResponse {
    "thangNam"?: Dayjs | null;
    "ngayNhanVien"?: Dayjs | null;
    "ngayLanhDaoPhong"?: Dayjs | null;
    "ngayBanDieuHanh"?: Dayjs | null;
}

export class CauHinhHanChotKPIRequest {
    "id": number;
    "thangNam"?: string | null;
    "ngayNhanVien": number;
    "ngayLanhDaoPhong": number;
    "ngayBanDieuHanh": number;
    "ghiChu": string;
}

/// Tệp mẫu Hợp đồng lao động đang được cấu hình
export class CauHinhHopDongFile {
    "idTaiLieu": number;
    "tenTep": string;
    "duongDan": string;
    "dinhDang": string;
    "ngayCapNhat"?: string | null;
    /// Các tham số {..} đang có trong tệp mẫu, chỉ đọc được với tệp .docx
    "dsThamSo"?: Array<string>;
}

export class LanhDaoPhuTrachPhongRequest {
    "idNhanVien": number;
    "loaiPhuTrachs"?: Array<{ idDonVi: number; loai: number }>;
}

/// Bộ đếm số hiệu văn bản của một năm, số hiệu có dạng {số}/{năm}/{mã}
export class SoHieuVanBan {
    "id": number;
    "loaiVanBan": string;
    "tenLoaiVanBan": string;
    "nam": number;
    "maVanBan": string;
    "soHienTai": number;
    "doDaiSo": number;
    "soHieuGanNhat": string;
    "soHieuTiepTheo": string;
    "soVanBanDaCap": number;
    "soLonNhatDaDung": number;
    "ngayCapNhat"?: Dayjs | null;
}

export class SoHieuVanBanRequest {
    "id": number;
    "loaiVanBan": string;
    "nam": number;
    "maVanBan": string;
    "soHienTai": number;
    "doDaiSo": number;
}

/// Loại văn bản đang dùng bộ đếm số hiệu, khớp với Constants.LoaiSoHieuVanBan phía máy chủ
export const loaiSoHieuVanBan = [
    { value: "HOPDONGDIENTU", label: "Hợp đồng lao động điện tử" },
];
